import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./login/loginSlice.js";
import formReducer from "./actions/form_slice.js";
import searchReducer from "./actions/search_slice.js";
import trackerReducer from "./actions/tracker_slice.js";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    form: formReducer,
    search: searchReducer,
    tracker: trackerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: [
          "form.tanfdt_form_type.Date",
          "form.pregnancylist_form_type.Date,form.verificationslist_form_type.Date",
          "search.tanfdt_form_type.Date",
          "search.pregnancylist_form_type.Date,form.verificationslist_form_type.Date",
          "tracker.tanfdt_form_type.Date",
          "tracker.pregnancylist_form_type.Date,form.verificationslist_form_type.Date",
        ],
      },
    }),
});
